import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import { Row, Col, Modal, ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap';
import CancelIcon from 'components/icons/Cancel';
import Image from 'components/Image';
import ComponentTitle from '../shared/ComponentTitle';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

/**
 * Class representing the images uploaded by the station for the current weather conditions.
 */

class StationImages extends Component {
  static propTypes = {
    images: PropTypes.array.isRequired,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    dimensions: PropTypes.object,
    enableModal: PropTypes.bool,
    chromeless: PropTypes.bool,
    titleType: PropTypes.string
  }

  static defaultProps = {
    title: '',
    dimensions: {
      'xs': 6
    },
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  render() {
    const { title, titleColor, images = [], dimensions, enableModal, chromeless, titleType } = this.props;

    if (!images.length) {
      return null;
    }

    return (
      <div className="StationImages">
        <ComponentTitle titleType={titleType} title={title} color={titleColor} classes="StationImages-header" />
        <Row className="StationImages-container" >
          {images.map((image, i) => <StationImageUnit image={image} key={i} dimensions={dimensions} enableModal={enableModal} chromeless={chromeless} />)}
        </Row>
      </div>
    );
  }
}

class StationImageUnit extends Component {
  static propTypes = {
    image: PropTypes.object.isRequired,
    dimensions: PropTypes.object.isRequired,
    enableModal: PropTypes.bool,
    chromeless: PropTypes.bool
  };

  state = {
    showModal: false
  }

  _toggleModal() {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  render() {
    // Use title if no separate alt_text is defined
    const {
      image = {},
      enableModal,
      chromeless,
      dimensions: { xs = 6, md, lg, xl } = {}
    } = this.props;

    const { showModal } = this.state;

    const { title, staticUri, destinationUri, altText } = image;

    const alt = altText || title;

    const scaledImage = `${staticUri}?auto=webp&disable=upscale&width=460`;
    const cellStyles = {backgroundImage: `url(${scaledImage})`};
    const componentclassNames = classNames('StationImageUnit', (xl ? `col-xl-${xl}` : ''));

    const thumbnailClassnames = classNames(
      'StationImageUnit-thumbnail',
      {
        'StationImageUnit-thumbnail--clickable': enableModal
      }
    );

    const titleClassnames = classNames(
      'StationImageUnit-imageTitle',
      {
        'StationImageUnit-imageTitle--clickable': enableModal
      }
    );

    const showHyperlink = destinationUri && !enableModal;

    return (
      <Col xs={xs} md={md} lg={lg} className={componentclassNames}>
        <div className={thumbnailClassnames} style={cellStyles} onClick={() => this._toggleModal()}>
          {/* The following image tag is here for accessibility purposes */}
          <Image src={scaledImage} alt={alt} imageClassNames={"StationImageUnit-image"} enableImgOpt={false} />
          {showHyperlink ? <a className="StationImageUnit-thumbnailImageLink" href={destinationUri} target="_top" /> : null}
        </div>
        <h3 className={titleClassnames} onClick={() => this._toggleModal()}>
          {showHyperlink ? <a href={destinationUri} target="_top">{title}</a> : title}
        </h3>
        { enableModal &&
        <ImageModal
          title={title}
          imageSrc={staticUri}
          altText={alt}
          destinationUri={destinationUri}
          showModal={showModal}
          onHideModal={() => this._toggleModal()}
          chromeless={chromeless}
        />
        }
      </Col>
    );
  }
}

class ImageModal extends Component {
  static propTypes = {
    title: PropTypes.string,
    altText: PropTypes.string,
    imageSrc: PropTypes.string,
    destinationUri: PropTypes.string,
    showModal: PropTypes.bool.isRequired,
    onHideModal: PropTypes.func.isRequired,
    chromeless: PropTypes.bool
  }

  render() {
    const {
      showModal,
      title,
      altText,
      imageSrc,
      destinationUri,
      onHideModal,
      chromeless
    } = this.props;

    const imgHeight = typeof window !== 'undefined' ? (document.documentElement.clientHeight) - 150 : 150;
    const imageStyles = {
      objectFit: 'contain'
    };

    return (
      <Modal className="StationImageModal"
             show={showModal}
             onHide={onHideModal}
             backdrop
             dialogClassName="StationImageModal-modalDialog"
             aria-labelledby="contained-modal-title-lg">
        { title &&
          <ModalHeader className="StationImageModal-header" closeButton>
            <ModalTitle>{destinationUri ? <a className="StationImageModal-title" href={destinationUri} target="_top">{title}</a> : title}</ModalTitle>
          </ModalHeader>
        }
        <ModalBody className={classNames('StationImageModal-body', {'StationImageModal-body--chromeless': chromeless})}>
        { !title && <span className="StationImageModal-close" onClick={() => onHideModal()}><CancelIcon color="#FFFFFF" /></span>}
          <Image height={imgHeight} src={imageSrc} alt={altText} imageClassNames={"StationImageModal-img"} imageStyles={imageStyles}/>
          {destinationUri ? <a className="StationImageUnit-thumbnailImageLink" href={destinationUri} target="_top" /> : null}
        </ModalBody>
      </Modal>
    );
  }
}

export default StationImages;



// WEBPACK FOOTER //
// ./app/components/weather/StationImages.js